import { useFadeIn } from '../../../hooks/useFadeIn';

export default function Services() {
  const { ref, isVisible } = useFadeIn({ threshold: 0.1 });

  const services = [
    {
      icon: 'ri-shield-check-line',
      title: 'メンタルヘルス不調の予防',
      description: '従業員のストレス状態を早期発見し、不調を未然に防ぎます'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: '休職者・復職者の対応支援',
      description: 'スムーズな復職と再発防止をサポートします'
    },
    {
      icon: 'ri-user-voice-line',
      title: 'ハラスメント対応',
      description: '社内外のハラスメント案件に専門家が対応します'
    },
    {
      icon: 'ri-team-line',
      title: '新入社員・中途社員のケア',
      description: '環境変化によるストレスを軽減し、定着率を向上させます'
    }
  ];

  return (
    <section id="services" className="min-h-[75vh] py-24 bg-white flex items-center">
      <div 
        ref={ref}
        className={`max-w-7xl mx-auto px-6 w-full transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-serif text-[#2C2C2C] leading-relaxed">
            医学的根拠に基づいた、<br />
            包括的なメンタルヘルスサポート
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className={`text-center group cursor-pointer transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="mb-6 flex justify-center">
                <div className="w-20 h-20 rounded-full bg-[#E8F4F8] flex items-center justify-center group-hover:bg-[#4A7BA7] transition-colors duration-300">
                  <i className={`${service.icon} text-4xl text-[#1A3B5C] group-hover:text-white transition-colors duration-300`}></i>
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#1A3B5C] mb-4">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
